import * as React from 'react';
import { TabStyles } from '@tableau/widgets';
import { CommonStyles } from '../common/react/CommonStyles';

export namespace UserSettingsHelper {
  const firstColumnDiv: React.CSSProperties = {
    width: '150px',
    paddingLeft: '0px'
  };

  const secondColumn: React.CSSProperties = {
    height: '16px',
    paddingLeft: '20px'
  };

  const secondColumnDiv: React.CSSProperties = {
    borderBottom: `1px solid ${CommonStyles.Colors.DividerLineColor}`,
    width: '800px',
  };

  export const getSectionDividerLine = (): JSX.Element => {
    return (
        <tr>
          <td><div style={firstColumnDiv}></div></td>
          <td style={secondColumn}><div style={secondColumnDiv}></div></td>
        </tr>
    );
  };
}